export default "__VITE_ASSET__C3yIUI8F__"